<template>
  <div
    class="cards span_1_of_5"
    :style="cardStyle"
  >
    <span
      v-show="!isSelected"
      class="pt-1 success_hv"
    />
    <span
      v-show="isSelected && allowDeselection"
      class="pt-1 remove_item_card"
    ><font-awesome-icon
      :icon="['far', 'times-circle']"
      class="success_hv"
    /></span>
    
    <div
      class="beneficiary-card cursor-pointer"
      :data-charity-id="beneficiary.BeneficiaryAccountId"
    >
      <div class="search-item-image">
        <a
          class="charity"
          href="#"
        ><div
          class="item-image"
          :style="{ backgroundImage: 'url(' + imagePath + ')' }"
        />
        </a>
      </div>
      <div class="search-item-desc">
        <h3>
          <a
            class="charity"
            href="#"
          >{{ beneficiaryName }}</a>
        </h3>

        <ProgressBar  
          v-if="settings.showLoadingBar"  
          :progress-value="progressValue"
          :styling="progressBarSettings.styleSettings"
        />

        <div class="search-item-btns">         
          <a
            v-if="settings.driverButton.show"
            :style="{ background: driverButtonBackground }"
            :href="donationLink"
            class="search-item-donate transition"
          ><span class="fa fa-heart" />{{ settings.driverButton.text }}</a>
          <a
            v-if="settings.secondaryButton.show"
            :style="{ background: secondaryButtonBackground }"
            :href="startFrdLink"
            class="search-item-fundraise transition"
          >{{ settings.secondaryButton.text }}</a>
          <div class="raised-amount">
            <h4
              v-if="settings.amount.text"
              class="amount-text"
            >
              {{ settings.amount.text }}
            </h4>
            <span
              v-if="settings.amount.show"
              class="amount-value"
            >$<span id="GfEcbTotal">{{ totalRaised }}</span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ProgressBar from "./ProgressBar";
import defaultSettings from "../common/defaultSettings";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
    components: {FontAwesomeIcon, ProgressBar},
    props: {
        beneficiary: {
            type: Object,
            default: () => {}
        },

        beneficiaryName: {
            type: String,
            default: ""
        },

        allowDeselection: {
            type: Boolean,
            default: true
        },

        imagePath: {
          type: String,
          default: ""
        },

        isSelected: {
          type: Boolean,
          default: false
        },

        imageSize: {
            type: String,
            default: "200px"
        },
        
        minWidth: {
            type: String,
            default: "210px"
        },
        
        componentSettings: {
            type: Object,
            default: () => {}
        },
        
    },

    data() {
      return {
        settings :{
          showLoadingBar : false,
          driverButton: {},
          secondaryButton: {},
          amount: {}
        },
        progressValue: 0,
        progressBarSettings: {          
            styleSettings: {
                fillColour: '#117ec2',
                trackColour: '#ddd'
            }
        },
      }
    },
    computed: {              
        totalRaised () {
          if(!this.beneficiary.BeneficiaryTotal) return "0";

          var total = this.beneficiary.BeneficiaryTotal;
          return (total === "" && !isNaN(total)) ? "0" : this.formattedFinancialFigure(total);
        },
        driverButtonBackground() {
          if(this.beneficiary.BeneficiaryTheme && this.beneficiary.BeneficiaryTheme.DriverButtonBackgroundColour) 
              return this.beneficiary.BeneficiaryTheme.DriverButtonBackgroundColour;
          
          return defaultSettings.DriverButtonBackgroundColour;
        },
        secondaryButtonBackground() {
          if(this.beneficiary.BeneficiaryTheme && this.beneficiary.BeneficiaryTheme.SecondaryButtonColour)                         
              return this.beneficiary.BeneficiaryTheme.SecondaryButtonColour;
          
          return defaultSettings.SecondaryButtonColour;
        },

        logoSize() {
            return { width: this.imageSize, height: this.imageSize };
        },

        cardStyle(){
          return { 'min-width': this.minWidth};
        },

        donationLink(){          
          return this.buildLink(this.settings.driverButton.urlLink);
        },
        
        startFrdLink(){
          return this.buildLink(this.settings.secondaryButton.urlLink);
        }
    },
    created(){
       this.settings.driverButton = Object.assign(this.settings.driverButton, defaultSettings.BENEFICIARYBOXRAISE_DRIVERBUTTON_DEFAULTS);
       this.settings.secondaryButton = Object.assign(this.settings.secondaryButton, defaultSettings.BENEFICIARYBOXRAISE_SECONDARYBUTTON_DEFAULTS);
       this.settings.amount = Object.assign(this.settings.amount, defaultSettings.BENEFICIARYBOXRAISE_AMOUNT_DEFAULTS);
    },    
    mounted() {      
      if (!this.componentSettings)
            return;
      if (this.componentSettings.showLoadingBar)            
          this.settings.showLoadingBar = this.componentSettings.showLoadingBar;

      if (this.componentSettings.driverButton)
          this.settings.driverButton = this.componentSettings.driverButton;
      
      if (this.componentSettings.secondaryButton)
          this.settings.secondaryButton = this.componentSettings.secondaryButton;

      if (this.componentSettings.amount)
          this.settings.amount = this.componentSettings.amount;     

      this.loadProgressbarData();
    },
    methods: {
      
      buildLink (url){
        return url.replace('{{Id}}', this.beneficiary.BeneficiaryAccountId);
      },

      loadProgressbarData (){
        var benTotal = this.beneficiary.BeneficiaryTotal;           
        var benTarget = this.beneficiary.BeneficiaryTarget;    
        var total = (benTotal === "" && !isNaN(benTotal)) ? 0 : parseInt(benTotal);
        var target = (benTarget === "" && !isNaN(benTarget)) ? 100 : parseInt(benTarget);
        this.progressValue = target ? parseInt((total / target) * 100) : 0;        
      },

      formattedFinancialFigure(val) {
          return parseFloat(val).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')          
      },

    },
};
</script>
<style scoped>
  
@media (hover: hover) {
	.cards:hover .success_hv {
		display: block;
		-webkit-transition: all 0.5s;
	}
} 

.success_hv {
	position: absolute;
	right: 100px;
  top: -14px;
  display: none; 
	z-index: 1;
	font-size: 1.5em;
	color: #f57c33;
}

.remove_item_card {
	position: relative;
	left: 200px;
	top: 5px;
	z-index: 1;  
}

.remove_item_card:before {
	color: #f57c33;
	padding: 0px 4px;
	font-size: 1.5em;
}

.amount-text {
    color: #2f2f2f !important;
    font-weight: 600 !important;    
    font-size: 14px !important;
    margin: 0;
    padding: 10px 10px 5px;
}

.charity{
    color: #333333 !important;
    font-weight: 500 !important;
    padding: 0;
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
}​​​

.search-item-desc > h3 > a.charity{
    padding: 0;
}

.search-item-image > .charity {
    padding: 20px;
}

.search-item-btns a span.fa {
    margin-right: 7px;
}

.search-item-image {
    background: #fff;
}

.transition {
    -moz-transition: all 0.4s;
    -o-transition: all 0.4s;
    -ms-transition: all 0.4s;
    -webkit-transition: all 0.4s;
    transition: all 0.4s;
}

.item-image {
    background-repeat: no-repeat;
    background-position: center center;
    display: block;
    overflow: hidden;
    background-size: contain;   
    margin: 0 auto;
    width: 100%;
    height: 120px;  
    border-radius: 0;
    background-color: transparent;
}

.search-item-desc h3 {
	font-size: 15px !important;
    font-weight: 500 !important;
    margin-bottom: 10px;
    font-weight: bold;
    margin: 25px auto;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 80%;

    padding: 0 25px 10px;
    margin-bottom: 0;
    padding-bottom: 10px;
    width: 100%;

}

.search-item-btns {
    margin-bottom: 20px;
}

.search-item-btns a.search-item-donate {
    background: #f47d32;
    color: #fff;
}

a.charity:hover,
.search-item-btns a:hover{
    text-decoration: none !important;
}

.search-item-btns a {
	color: #fff !important;
    font-weight: 400 !important;
    text-decoration: none;    
    display: block;
    padding: 7px;
    width: 80%;
    margin: 10px auto;
    border-radius: 50px;
    font-size: 14px;
}

.group {
    zoom: 1;
}

.row-full {
    width: 74.5vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -37.6vw;
    margin-right: -37.6vw;
    text-align: center;
}

.cards {
	  border-radius: 5px;    
    cursor: pointer;
    background: #fff;
    padding: 0;
    text-align: center;
}

.cards {
    display: inline-block; 
    margin: 1% .5% 1% .5%;
    min-width: 210px;
} 

.span_5_of_5 {
	width: 100%;
}

.span_4_of_5 {
  	width: 79.68%;
}

.span_3_of_5 {
  	width: 59.36%;
}

.span_2_of_5 {
  	width: 39.04%;
}

.span_1_of_5 {
  	width: 18.72%;
}

.button-show{
	cursor: pointer;
    background: #005bab!important;
    color: #fff !important;
    border: 3px solid #005bab;
    min-width: 165px !important;
    padding: 13px 30px !important;
    margin: 10px 0;
    border-radius: 3px !important;
}

.button-show:hover{
	filter: brightness(105%);
	-webkit-border-radius: 3px !important;
	-moz-border-radius: 3px !important;
	border-radius: 3px !important;
	box-shadow: 0 20px 38px rgba(0, 0, 0, 0.16);
    -ms-transform: translateY(-3px);
    transform: translateY(-3px);
    -webkit-transform: translateY(-3px);
}

</style>